import PictorialChart from "../../../../../src/core/PictorialChart";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  PictorialChart,
  Playground,
  React
};